<template>
  <v-container fluid class="login-container">
    <v-row justify="center" align="center" class="min-height-screen">
      <v-col cols="12" sm="10" md="8" lg="6" xl="5">
        <div class="main-wrapper">
          <!-- Loading Dialog -->
          <v-dialog v-model="dialog" persistent max-width="300">
            <v-card class="loading-dialog elevation-8">
              <v-card-text class="text-center pa-8">
                <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
                <p class="mt-4 subtitle-1">Validando...</p>
              </v-card-text>
            </v-card>
          </v-dialog>

          <!-- Back Button -->
          <v-card class="back-card elevation-4 mb-4" @click="returnarInicio">
            <v-card-text class="d-flex align-center pa-3">
              <div class="back-icon">
                <v-icon color="white" size="20">mdi-keyboard-return</v-icon>
              </div>
              <span class="back-text">Retornar ao Iníciosssss</span>
            </v-card-text>
          </v-card>

          <!-- Login Form -->
          <v-card
            class="login-card elevation-8 mb-4"
            v-show="(!param.disponivel || param.disponivel.length == 0) && param.listaApto.length == 0"
          >
            <div class="card-header">
              <div class="header-icon">
                <v-icon size="32" color="white">mdi-account-key</v-icon>
              </div>
              <h2 class="header-title">Validação de Acessos</h2>
            </div>

            <v-card-text class="pa-6">
              <v-alert dense text type="info" class="custom-alert mb-4" border="left">
                Digite o seu <strong>{{ labelMain() }}</strong> <small class="text-caption"> (somente números)</small>,
                em seguida clique em validar.
              </v-alert>

              <v-text-field
                v-model="inputFormatted"
                :label="labelPlasce"
                required
                outlined
                class="custom-input"
                :prepend-inner-icon="param?.Selecionado?.alunos == 1 ? 'mdi-card-account-details' : 'mdi-account'"
                @input="formatInput"
                :maxlength="param?.Selecionado?.alunos == 1 ? 15 : 14"
                :placeholder="param?.Selecionado?.alunos == 1 ? '0000000000' : '000.000.000-00'"
              />

              <v-btn color="primary" class="validate-btn elevation-4" block large @click="validate">
                <v-icon left>mdi-check-circle</v-icon>
                Validar
              </v-btn>

              <v-alert v-show="!encontrado" type="error" class="error-alert mt-4" border="left" dense>
                <v-icon slot="prepend">mdi-alert-circle</v-icon>
                Este {{ labelMain() }} não está ativo em nosso cadastro!
              </v-alert>
            </v-card-text>
          </v-card>

          <!-- Results for Family (ID 14) -->
          <div v-show="optFamilia && param?.Selecionado?.id == 14" class="results-container">
            <v-card
              v-for="(item, index) in param.listaApto"
              :key="index"
              class="result-card elevation-4 mb-4"
              :style="{ 'animation-delay': `${index * 0.1}s` }"
            >
              <div class="result-header">
                <v-icon color="primary" class="mr-2">mdi-school</v-icon>
                <span class="result-title">Dados Encontrados</span>
              </div>

              <v-card-text class="pa-4">
                <div class="info-item"><strong>Instituição:</strong> {{ item.instituicao }}</div>
                <div class="info-item"><strong>Aluno:</strong> {{ item.aluno }}</div>
                <div class="info-item"><strong>Responsável:</strong> {{ item.responsavel }}</div>

                <div class="action-section mt-4" v-if="item.apto == 1">
                  <v-btn
                    v-if="item.avaliado == 0"
                    block
                    color="success"
                    class="action-btn elevation-2"
                    large
                    @click="startAvaliar(item)"
                  >
                    <v-icon left>mdi-clipboard-text</v-icon>
                    Responder Questionário
                  </v-btn>
                  <v-alert v-if="item.avaliado == 1" type="warning" dense class="status-alert">
                    <v-icon slot="prepend">mdi-check-circle</v-icon>
                    Questionário já foi respondido!
                  </v-alert>
                </div>

                <v-alert v-if="item.apto == 0" type="error" dense class="status-alert">
                  <v-icon slot="prepend">mdi-block-helper</v-icon>
                  Não está apto a responder este questionário!
                </v-alert>
              </v-card-text>
            </v-card>
          </div>

          <!-- Results for Family (ID 16) -->
          <div v-show="optFamilia && param.Selecionado.id == 16" class="results-container">
            <v-card
              v-for="(item, index) in param.listaApto"
              :key="index"
              class="result-card elevation-4 mb-4"
              :style="{ 'animation-delay': `${index * 0.1}s` }"
            >
              <div class="result-header">
                <v-icon color="primary" class="mr-2">mdi-account-group</v-icon>
                <span class="result-title">Família Localizada</span>
              </div>

              <v-card-text class="pa-4">
                <div class="info-item">
                  <strong>Instituição:</strong>
                  <span class="institution-name">{{ item.instituicao }}</span>
                </div>
                <div class="info-item"><strong>Responsável:</strong> {{ item.responsavel }}</div>
                <div class="info-item">
                  <strong>Aluno(s):</strong>
                  <div class="students-list">
                    <span v-for="(al, id) in item.data" :key="id" class="student-item">
                      {{ al.aluno }}
                    </span>
                  </div>
                </div>

                <div class="action-section mt-4" v-if="item.apto > 0">
                  <v-btn
                    v-if="item.avaliado == 0"
                    block
                    color="success"
                    class="action-btn elevation-2"
                    large
                    @click="startAvaliar(item)"
                  >
                    <v-icon left>mdi-clipboard-text</v-icon>
                    Responder Questionário
                  </v-btn>
                  <v-alert v-if="item.avaliado > 0" type="warning" dense class="status-alert">
                    <v-icon slot="prepend">mdi-check-circle</v-icon>
                    Questionário já foi respondido!
                  </v-alert>
                </div>

                <v-alert v-if="item.apto == 0" type="error" dense class="status-alert">
                  <v-icon slot="prepend">mdi-block-helper</v-icon>
                  Não está apto a responder este questionário!
                </v-alert>
              </v-card-text>
            </v-card>
          </div>

          <!-- Results for Other Questionnaires -->
          <div v-show="optFamilia && quest" class="results-container">
            <v-card
              v-for="(item, index) in param.listaApto"
              :key="index"
              class="result-card elevation-4 mb-4"
              :style="{ 'animation-delay': `${index * 0.1}s` }"
            >
              <div class="result-header">
                <v-icon color="primary" class="mr-2">mdi-badge-account</v-icon>
                <span class="result-title">Dados Profissionais</span>
              </div>

              <v-card-text class="pa-4">
                <div class="info-item">
                  <strong>Instituição:</strong>
                  <span class="institution-name">{{ item.instituicao }}</span>
                </div>
                <div class="info-item"><strong>Nome:</strong> {{ item.nome }}</div>
                <div class="info-item">
                  <strong>Matrícula(s):</strong>
                  <div class="matriculas-list">
                    <span v-for="(al, id) in item.data" :key="id" class="matricula-item">
                      {{ al.cargo }} - {{ al.matricula }}-{{ al.contrato }}
                    </span>
                  </div>
                </div>

                <div class="action-section mt-4">
                  <v-btn
                    v-if="item.avaliado == 0"
                    block
                    color="success"
                    class="action-btn elevation-2"
                    large
                    @click="startAvaliar(item)"
                  >
                    <v-icon left>mdi-clipboard-text</v-icon>
                    Responder Questionário
                  </v-btn>
                  <v-alert v-if="item.avaliado > 0" type="warning" dense class="status-alert">
                    <v-icon slot="prepend">mdi-check-circle</v-icon>
                    Questionário já foi respondido!
                  </v-alert>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/*import { Libs } from "--------libs/libs";
import filtros from "--------services/filters";
import { mapGetters,mapMutations } from "vuex";*/
import { mapActions, mapGetters } from "vuex";
import filtros from "../libs/filters";

export default {
  name: "login",
  data: () => ({
    tab: 0,
    dados: {
      datas: [],
      matricula: [],
    },
    msnreturn: "",
    dialog: false,
    optFamilia: false,
    localizado: true,
    encontrado: true,
    cpfFormatted: "", // Campo formatado para exibição
    inputFormatted: "", // Campo formatado para exibição (CPF ou CGM)
  }),
  components: {},
  filters: filtros,
  computed: {
    ...mapGetters({ param: "avaliacao/param" }),
    nome() {
      let tx = "";
      if (this.dados.matricula.length > 0) {
        tx = this.dados.matricula[0].nome;
      }

      return tx;
    },
    quest() {
      let t;
      let array_param = [15, 17, 18];
      let id = this.param?.Selecionado?.id;
      if (array_param.includes(parseInt(id))) {
        t = true;
      } else {
        t = false;
      }
      return t;
    },
    labelPlasce() {
      let tx = "";
      if (this.param?.Selecionado?.alunos == 1) {
        tx = "Digite seu CGM somente números:";
      } else {
        tx = "Digite seu CPF somente números:";
      }
      return tx;
    },
  },
  methods: {
    ...mapActions({ requestValidar: "avaliacao/requestValidar" }),

    formatInput(value) {
      // Remove tudo que não for número
      let numbers = value.replace(/\D/g, "");

      if (this.param?.Selecionado?.alunos == 1) {
        // CGM - sem máscara, apenas números
        numbers = numbers.substring(0, 15); // Limite para CGM
        this.inputFormatted = numbers;
        this.param.cpf = numbers; // Ainda usa cpf no store para compatibilidade
      } else {
        // CPF - com máscara
        numbers = numbers.substring(0, 11);

        if (numbers.length <= 3) {
          this.inputFormatted = numbers;
        } else if (numbers.length <= 6) {
          this.inputFormatted = numbers.replace(/(\d{3})(\d+)/, "$1.$2");
        } else if (numbers.length <= 9) {
          this.inputFormatted = numbers.replace(/(\d{3})(\d{3})(\d+)/, "$1.$2.$3");
        } else {
          this.inputFormatted = numbers.replace(/(\d{3})(\d{3})(\d{3})(\d+)/, "$1.$2.$3-$4");
        }

        this.param.cpf = numbers;
      }
    },

    async validate() {
      this.dialog = true;

      const id = this.param?.Selecionado?.id;
      const numbers = this.param.cpf.replace(/\D/g, "");

      // Se for CPF, aborta se não tiver 11 dígitos
      if (!this.param?.Selecionado?.alunos && numbers.length !== 11) {
        alert("CPF deve conter exatamente 11 dígitos (incluindo zeros à esquerda). Corrija e tente novamente.");
        this.dialog = false;
        return;
      }

      // Montar parâmetros baseado no tipo (CGM ou CPF)
      const j = {
        id_questionario: id,
      };

      if (this.param?.Selecionado?.alunos == 1) {
        j.cgm = numbers; // Enviar como CGM
      } else {
        j.cpf = numbers; // Enviar como CPF
      }

      try {
        const { data } = await this.requestValidar(j);

        // Verificar se retornou dados válidos
        if (data.data && data.data.length > 0) {
          this.param.disponivel = data.data;
          // Redirecionar para a página de questionários disponíveis
          this.$router.push("/questionarios-disponiveis");
        } else {
          // Só mostra alert se não retornar dados ou se houver erro específico
          if (data.error) {
            alert(data.error);
          } else {
            alert("Nenhum questionário disponível encontrado.");
          }
          this.encontrado = false;
        }
      } catch (error) {
        console.error("Erro na validação:", error);
        this.param.listaApto = [];
        this.encontrado = false;
        alert("Erro na validação. Tente novamente.");
      } finally {
        this.dialog = false;
      }
    },

    labelMain() {
      let tx = "";
      if (
        this.param &&
        this.param.Selecionado &&
        typeof this.param?.Selecionado?.alunos !== "undefined" &&
        this.param?.Selecionado?.alunos == 1
      ) {
        tx = "CGM";
      } else {
        tx = "CPF";
      }
      return tx;
    },

    returnarInicio() {
      this.param.listaApto = [];
      this.param.disponivel = []; // Limpar dados disponíveis
      this.tab = 0;
      this.param.cpf = "";
      this.inputFormatted = ""; // Limpa o campo formatado
      this.dados.datas = [];
      this.$router.push("/");
    },

    selecionar() {
      this.tab = 1;
    },
    startAvaliar(item) {
      this.param.pessoa = item;
      this.$router.push("/questionario");
    },
    salvar(id) {
      let js = {};
      js.cpf = this.param.cpf;
      js.datas = id;
    },
  },
  mounted: function () {
    // Verificar se já existem questionários disponíveis
    if (this.param.disponivel && this.param.disponivel.length > 0) {
      this.$router.push("/questionarios-disponiveis");
    }
  },
};
</script>

<style scoped>
.login-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  padding: 24px 16px;
}

.min-height-screen {
  min-height: calc(100vh - 48px);
}

.main-wrapper {
  animation: fadeInUp 0.8s ease-out;
}

.loading-dialog {
  border-radius: 16px !important;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
}

.back-card {
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  border-radius: 12px !important;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.back-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(231, 76, 60, 0.3) !important;
}

.back-icon {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.back-text {
  color: white;
  font-weight: 500;
  font-size: 1rem;
}

.login-card {
  border-radius: 16px !important;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  overflow: hidden;
  animation: slideInUp 0.6s ease-out 0.2s both;
}

.card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 24px;
  text-align: center;
  position: relative;
}

.card-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.header-icon {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  margin-bottom: 16px;
}

.header-title {
  position: relative;
  z-index: 1;
  color: white;
  font-weight: 300;
  margin: 0;
}

.custom-alert {
  border-radius: 8px !important;
  background: rgba(33, 150, 243, 0.05) !important;
}

.custom-input {
  margin-bottom: 16px;
}

.validate-btn {
  border-radius: 8px !important;
  height: 48px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
}

.error-alert {
  border-radius: 8px !important;
  animation: shake 0.5s ease-in-out;
}

.results-container {
  animation: fadeInUp 0.6s ease-out 0.4s both;
}

.result-card {
  border-radius: 12px !important;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: slideInLeft 0.6s ease-out both;
}

.result-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.2) !important;
}

.result-header {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  padding: 16px 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.result-title {
  font-weight: 600;
  color: #2c3e50;
  font-size: 1rem;
}

.info-item {
  margin-bottom: 12px;
  line-height: 1.5;
  color: #34495e;
}

.info-item strong {
  color: #2c3e50;
  margin-right: 8px;
}

.institution-name {
  color: #3498db;
  font-weight: 600;
}

.students-list,
.matriculas-list {
  margin-top: 8px;
  margin-left: 16px;
}

.student-item,
.matricula-item {
  display: block;
  padding: 4px 0;
  color: #555;
  border-left: 3px solid #e74c3c;
  padding-left: 12px;
  margin-bottom: 4px;
}

.action-section {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  padding-top: 16px;
}

.action-btn {
  border-radius: 8px !important;
  height: 48px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
}

.status-alert {
  border-radius: 8px !important;
  margin: 0 !important;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes shake {
  0%,
  100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  75% {
    transform: translateX(5px);
  }
}

/* Mobile Responsive */
@media (max-width: 599px) {
  .login-container {
    padding: 16px 8px;
  }

  .card-header {
    padding: 20px 16px;
  }

  .header-icon {
    width: 56px;
    height: 56px;
    margin-bottom: 12px;
  }

  .header-title {
    font-size: 1.3rem;
  }

  .back-text {
    font-size: 0.9rem;
  }

  .result-header {
    padding: 12px 16px;
  }

  .students-list,
  .matriculas-list {
    margin-left: 8px;
  }
}

@media (max-width: 959px) and (min-width: 600px) {
  .card-header {
    padding: 28px 20px;
  }
}

@media (min-width: 1264px) {
  .result-card {
    margin-bottom: 20px !important;
  }
}
</style>
